import type { PulseError } from "./errors";

export type PulseBatchConfig = {
  enabled?: boolean;
  maxSize?: number;
  flushIntervalMs?: number;
};

export type PulseClientConfig = {
  baseUrl: string;
  applicationId: string;
  tenantId?: string;
  accessToken?: string;
  getAccessToken?: () => Promise<string> | string;
  anonymousId?: string;
  getAnonymousId?: () => string | undefined;
  userId?: string;
  batch?: PulseBatchConfig;
  onError?: (error: PulseError) => void;
};

export function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
}
